import React from 'react';
import { Eye } from 'lucide-react';
import { cn } from '../cn';
/** Standard portal action to open a read-only transaction detail modal. */
export const ViewTransactionButton = ({ onClick, className, size = 'md', }) => {
    const dim = size === 'sm' ? 'h-8 w-8' : 'h-9 w-9';
    const icon = size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4';
    return (React.createElement("button", { type: "button", onClick: onClick, className: cn('inline-flex shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-600 shadow-sm transition hover:border-orange-200 hover:bg-orange-50 hover:text-orange-800', dim, className), "aria-label": "View transaction details" },
        React.createElement(Eye, { className: icon, "aria-hidden": true })));
};
export default ViewTransactionButton;
